const PNF = require('google-libphonenumber').PhoneNumberFormat;
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

export default {
  capitalize: (value) => {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },

  convertSec2hhmmss: (sec) => {
    const totalSeconds = parseInt(sec);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
    let seconds = totalSeconds - (hours * 3600) - (minutes * 60);

    // round seconds
    seconds = Math.round(seconds * 100) / 100;

    let result = (hours < 10 ? `0${hours}` : hours);
    result += `:${minutes < 10 ? `0${minutes}` : minutes}`;
    result += `:${seconds < 10 ? `0${seconds}` : seconds}`;
    return result;
  },

  dashIfNull: (value) => {
    if (value === null || value === '') {
      return '-';
    }

    return value;
  },

  formatParagraph: (text) => {
    let result;
    result = `<p>${text}</p>`;
    result = result.replace(/\r\n\r\n/g, '</p><p>').replace(/\n\n/g, '</p><p>');
    result = result.replace(/\r\n/g, '<br />').replace(/\n/g, '<br />');

    return result;
  },

  formatPhoneNumber(value) {
    if (!value) return '-';

    console.log('format numeber', value);

    const phoneNumber = phoneUtil.parse(value, 'IT');
    return phoneUtil.format(phoneNumber, PNF.INTERNATIONAL);
  },
};



// WEBPACK FOOTER //
// ./src/filters/index.js